import { render } from "./WorkoutStatistics.vue?vue&type=template&id=303b2965&scoped=true"
import script from "./WorkoutStatistics.vue?vue&type=script&lang=js"
export * from "./WorkoutStatistics.vue?vue&type=script&lang=js"

import "./WorkoutStatistics.vue?vue&type=style&index=0&id=303b2965&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303b2965"]])

export default __exports__